<div class="button-card">
  <span>{{ input.name }}</span>
    <button class="settings-button" (click)="onEdit()" [title]="'button.edit' | translate">
      <img src="assets/icons/edit.svg" width="20" height="20" [alt]="'common.edit' | translate" />
    </button>
    <button class="flat-btn"
            (mousedown)="onButtonDown()"
            (mouseup)="onButtonUp()"
            (mouseleave)="onButtonUp()"
            (touchstart)="onButtonDown()"
            (touchend)="onButtonUp()">
      <div class="progress-bar" *ngIf="isHolding">
        <div class="progress" [style.width.%]="progress"></div>
      </div>
      {{ 'button.press' | translate }}
    </button>
</div>
